import type { ReactNode } from "react";

export function QuotesColumn(props: {
  twoColumn?: boolean | undefined;
  children: ReactNode;
}) {
  // Full width when the quote card is stacking its columns (narrow screens).
  return (
    <div
      className={`${props.twoColumn ? "w-1/2" : "w-[33%]"} pr-6 in-[.quote-card-narrow]:w-full`}
    >
      {props.children}
    </div>
  );
}
